(()=>{

  window.addEventListener('DOMContentLoaded', () => {
// card
    const media = gsap.matchMedia();
    document.querySelectorAll('.content__cards .swiper').forEach(swiper => {
      let swiperInstance = null;
      media.add("(max-width: 599px)", () => {
        swiperInstance = new Swiper(swiper, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          freeMode: true,
        });
        return () => {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        };
      });
    });

    //center-list
    document.querySelectorAll('.center-list a').forEach((item) => {
      const box = item.querySelector('.__box');
      if (box) {
        const overlay = box.cloneNode(true);
        overlay.classList.add('--overlay');
        item.appendChild(overlay);
      }
    });


    //accordion
    document.querySelectorAll('.content__accordions').forEach(accordions => {
      accordions.querySelectorAll('.__accordion').forEach(accordion => {
        if (accordion.dataset._initAccordion) return;
        accordion.dataset._initAccordion = '1';
        accordion.querySelector('.__toggle').addEventListener('click', (e) => {
          e.preventDefault();
          accordion.classList.toggle('--active');
          const content = accordion.querySelector('.__content');
          content.addEventListener('transitionend', () => {
            requestAnimationFrame(()=>{
              ScrollTrigger.update();
            });
          }, { once: true });
        });
      })
    })

    document.querySelectorAll('.alphabet-filter').forEach(filter => {
      if (filter.dataset._initAlphabet) return;
      filter.dataset._initAlphabet = '1';
      const toggle = filter.querySelector('.__toggle');
      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          filter.classList.toggle('--active');
        });
      }
    })

    // News item image aspect ratio check
    document.querySelectorAll('.__news-item .__img img').forEach(img => {
      const checkImageAspect = () => {
        if (img.naturalWidth && img.naturalHeight) {
          const aspectRatio = img.naturalWidth / img.naturalHeight;
          // If image is wider than 16:9 (more horizontal), use contain
          if (aspectRatio > 16/9) {
            img.classList.add('--contain');
          } else {
            img.classList.remove('--contain');
          }
        }
      };
      
      if (img.complete) {
        checkImageAspect();
      } else {
        img.addEventListener('load', checkImageAspect);
      }
    });


    //modal
    document.addEventListener('click', e => {
      if (e.target.closest('[data-modal-show]')) {
        e.preventDefault();
        e.stopPropagation();
        const modalId = e.target.closest('[data-modal-show]').getAttribute('data-modal-show');
        const modal = document.querySelector(modalId);
        if (modal) window.showModal(modal);
        requestAnimationFrame(()=>{
          ScrollTrigger.update();
        })
      }
      if (e.target.getAttribute('[data-modal-close]') || e.target.closest('[data-modal-close]')) {
        e.preventDefault();
        e.stopPropagation();
        const modal = e.target.closest('.modal');
        if (modal) window.closeModal(modal);
        requestAnimationFrame(()=>{
          ScrollTrigger.update();
        })
      }
    });

    // detect .modal-header sticky
    document.querySelectorAll('.modal').forEach(modal => {
      const scrollArea = modal.querySelector('.__scroll-area');
      const modalBox = modal.querySelector('.modal-box');
      const header = modal.querySelector('.modal-header');
      if (header) {
        ScrollTrigger.create({
          trigger: modalBox,
          start: 'top top',
          end: 'bottom top',
          scroller: scrollArea,
          onEnter: () => {
            header.classList.add('--sticky');
          },
          onLeaveBack: () => {
            header.classList.remove('--sticky');
          },
          onLeave: () => {
            header.classList.remove('--sticky');
          },
          onEnterBack: () => {
            header.classList.add('--sticky');
          },
        });
      }
    });
  });



  window.showModal = (modal) => {
    if (modal) {
      modal.classList.add('--active');
      document.body.classList.add('--modal-opened');
      if (window.lenis) {
        window.lenis.stop();
      }
    }
  }

  window.closeModal = (modal) => {
    if (modal) {
      modal.classList.remove('--active');
      if (document.querySelectorAll('.modal.--active').length === 0) {
        document.body.classList.remove('--modal-opened');
        if (window.lenis) {
          window.lenis.start();
        }
      }
    }
  }
})();